import React, { useEffect, useState } from 'react';
import { Button, List, Toast } from 'antd-mobile';
import { Checkbox, Space } from 'antd-mobile-v5';
import TitleComponent from '../../comm/title/title';
import { ApiCore } from '../../../../api';
import styles from './authorization.module.scss';

const Item = List.Item;
const Brief = Item.Brief;
const api = new ApiCore();

const explain = '我们非常重视您的隐私保护，为了给您提供完整的服务和优秀的用户体验，在注册绑定过程中我们需要向您申请以下信息获取权限：'
const data = [{
    "key": "name",
    "name": "姓名",
    "description": "用于医生工作室账号注册时输入的医生信息和医生身份验证",
    "authorize": true
},{
    "key": "hospital",
    "name": "所在医疗机构",
    "description": "用于医生工作室账号注册时输入的医生信息和医生身份验证",
    "authorize": true
},{
    "key": "department",
    "name": "所在科室",
    "description": "用于医生工作室账号注册时输入的医生信息和医生身份验证",
    "authorize": true
},{
    "key": "title",
    "name": "职称",
    "description": "用于医生工作室账号注册时输入的医生信息和医生身份验证",
    "authorize": true
}];

function Authorization(props: any) {

    // 选中的参数list
    const [paramsList, setParamsList] = useState<any>([]);
    // 选中的key
    const [checkedList, setCheckedList] = useState<any>([]);
    // 选中
    const [checked, setChecked] = useState<any>([]);

    

    useEffect(() => {
        document.title = '授权信息';

        // let info:any = null;
        // let authorizationInfo = sessionStorage.getItem('authorizationInfo')
        // if (authorizationInfo) {
        //     info = JSON.parse(authorizationInfo)
            
        //     for(let key in info) {
        //         if (info[key]) {
        //             defaultChecked.push(key)
        //         }
        //         setChecked(defaultChecked)
        //     }
        // }

        
        let pList: any = []
        let cList: any = []
        let obj: any = []
        let paramsList = sessionStorage.getItem('paramsList')
        let authChecked = sessionStorage.getItem('authChecked')

        data.length > 0 && data.map((i: any)=>{
            obj = {
                name: i.name,
                text: i.description,
                authorize: i.authorize
            }
            pList.push(obj)
            cList.push(i.key)
            
        })

        if (!authChecked) { // 首次加载
            setChecked(cList)
            setParamsList(pList)
        } else {
           
            if (paramsList) {
                let p:any = null;
                let oList: any = []
                p = JSON.parse(paramsList)
                p.map((i: any)=>{
                    let o = {
                        name: i.name,
                        text: i.description,
                        authorize: i.authorize
                    }
                    oList.push(o)
                })
                setParamsList(oList)
            } 
            setChecked(JSON.parse(authChecked))
        }

    }, [])

    const goBack = (b: any) => {

        if (!b) {
            paramsList.map((i: any)=>{
                i.authorize = false
            })
            checked.length = 0;
            setChecked([])
            sessionStorage.setItem('authChecked', JSON.stringify([]))
            sessionStorage.setItem('paramsList', JSON.stringify(paramsList))
        }

        let appCode = sessionStorage.getItem('appCode')
        api.GetAppTenantConfig({ appCode: appCode }).then(res => {
            if (res && res.code == '0') {
                
                let params = {
                    appCode: res.data.appCode,
                    list: paramsList,
                    otherTenantCode: res.data.tenantCode
                }
                
                api.GetAppAuthorize(params).then(res => {
                    if (res.code == '0') {
                        sessionStorage.setItem('authChecked', JSON.stringify(checked))
                        sessionStorage.setItem('paramsList', JSON.stringify(data))
                        props.history.push({ pathname: `/findList/createAccount/createAccount`, params: { checked: b, data: checked } })
                    }
                    else {
                        Toast.fail(res.message)
                    }
                })
            }
        })
    }

    const onChange = (valuesList: any) => {
        let pList: any = []
        data.length > 0 && data.map((i: any)=>{
            let obj = {
                name: i.name,
                text: i.description
            }
            if (valuesList.includes(i.key)) {
                obj['authorize'] = true
                i['authorize'] = true
            } else {
                obj['authorize'] = false
                i['authorize'] = false
            }
            
            pList.push(obj)
        })
        
        setParamsList(pList)
        setChecked(valuesList)

    }

    return (
        <div className={styles.authorization}>

            <TitleComponent title={'用户信息使用授权'} subTitle={explain} />

            <Checkbox.Group
                value={checked}
                onChange={onChange}
            >
                <Space direction='vertical'>
                    {data.map((i:any,index:any) => (
                        <Checkbox value={i.key} key={index}>
                            <span className={'title'}>{i.name}</span>
                            <div className={'subTit'}>{i.description}</div>
                        </Checkbox>
                    ))}

                </Space>
            </Checkbox.Group>

            <div className={styles.buttonGroup}>
                <Button
                    className={`${styles.btn} ${styles.cancel}`}
                    onClick={() => goBack(false)}
                >
                    不同意授权
                </Button>
                <Button
                    className={styles.btn}
                    onClick={() => goBack(true)}
                    disabled={checked.length == 0}
                >
                    同意授权
                </Button>
            </div>
        </div>
    )

}

export default Authorization;